import { DomainEvent } from "@/domains/events"

export class NftSelectionChangedEvent extends DomainEvent {
  static readonly TYPE = "selected-power.nft-selection-changed"
  readonly type = NftSelectionChangedEvent.TYPE
  constructor(
    public readonly selectedNftIds: number[],
    public readonly selectedVotePower: number,
  ) {
    super()
  }
}
